import { render } from "./STable.vue?vue&type=template&id=a6d4fe40&ts=true"
import script from "./STable.vue?vue&type=script&lang=ts"
export * from "./STable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QTh,QBadge,QSeparator,QItem,QSkeleton});
